import React from 'react';
import classnames from 'classnames';
import styles from './styles.mod.scss';
import FullStar from 'images/icons/stars/full.svg?react-svg';
import EmptyStar from 'images/icons/stars/empty.svg?react-svg';
import HalfStar from 'images/icons/stars/half.svg?react-svg';

export default function StarRating({ ratings, loading, className }) {
  const count = ratings.ratingCount;
  const rating = ratings.ratingValue;

  const fullStars = rating ? Math.round(rating) : 0;
  const hasHalfStar = rating > fullStars;
  const emptyStars = 5 - (hasHalfStar ? fullStars + 1 : fullStars);

  return (
    <div
      className={classnames(styles.container, className, {
        [styles.loading]: loading,
        [styles.empty]: !count
      })}
    >
      {Array(fullStars)
        .fill()
        .map((_, i) => (
          <FullStar key={`${i}-${fullStars}`} />
        ))}
      {hasHalfStar && <HalfStar />}
      {Array(emptyStars)
        .fill()
        .map((_, i) => (
          <EmptyStar key={`${i}-${emptyStars}`} />
        ))}
    </div>
  );
}
